import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  IconButton,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Switch,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MDButton from "components/MDButton";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { telemetry } from "globals/endpoints";
import CTLDialogContent from "application/components/styles/CTLDialogContent";
import { useMaterialUIController } from "context";
import { application } from "globals/endpoints";
import CTLNotification from "application/components/CTLNotification";
import MDTypography from "components/MDTypography";

const initialForm = {
  phoneSelect: "",
  macAddress: "",
  account: [
    {
      accountNo: "",
      label: "",
      extensionNo: "NA",
    },
  ],
  blf: [
    {
      key: "",
      type: "0",
      mode: "0",
      value: "",
      label: "",
      account: "",
      extension: "NA",
      extensionName: "",
      rluCode: "",
    },
  ],
  programmableKey: {
    softKey: [
      {
        name: "SoftKey 1",
        key: "1",
        type: "0",
        label: "",
        account: "",
        value: "",
      },
      {
        name: "SoftKey 2",
        key: "2",
        type: "0",
        label: "",
        account: "",
        value: "",
      },
      {
        name: "SoftKey 3",
        key: "3",
        type: "0",
        label: "",
        account: "",
        value: "",
      },
      {
        name: "SoftKey 4",
        key: "4",
        type: "0",
        label: "",
        account: "",
        value: "",
      },
    ],
    settingKey: [
      {
        label: "Up",
        key: "1",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Down",
        key: "2",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Left",
        key: "3",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Right",
        key: "4",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Ok",
        key: "5",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Cancel",
        key: "6",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Mute",
        key: "7",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "CONF",
        key: "8",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "TRAN",
        key: "9",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Hold",
        key: "10",
        type: "0",
        account: "",
        value: "",
      },
    ],
    settingSingleKey: [
      {
        label: "Speaker",
        key: "1",
        active: "0",
      },
      {
        label: "Headset",
        key: "2",
        active: "0",
      },
      {
        label: "VM",
        key: "3",
        active: "0",
      },
      {
        label: "Volume Up",
        key: "4",
        active: "0",
      },
      {
        label: "Volume Down",
        key: "5",
        active: "0",
      },
      {
        label: "Redial",
        key: "6",
        active: "0",
      },
    ],
  },
};

const typeMenu = [
  { value: "0", type: "N/A" },
  { value: "1", type: "Line" },
  { value: "2", type: "Speed Dial" },
  { value: "3", type: "BLF" },
  { value: "4", type: "BLF List" },
  { value: "5", type: "Voice Mail" },
  { value: "6", type: "Direct Pickup" },
  { value: "7", type: "Group Pickup" },
  { value: "8", type: "Call Park" },
  { value: "9", type: "Intercom" },
  { value: "10", type: "DTMF" },
  { value: "11", type: "Prefix" },
  { value: "12", type: "Local Group" },
  { value: "13", type: "XML Group" },
  { value: "14", type: "XML Browser" },
  { value: "15", type: "LDAP" },
  { value: "16", type: "Network Directories" },
  { value: "17", type: "Conference" },
  { value: "18", type: "Forward" },
  { value: "19", type: "Transfer" },
  { value: "20", type: "Hold" },
  { value: "21", type: "DND" },
  { value: "22", type: "Redial" },
  { value: "23", type: "Call Return" },
  { value: "24", type: "SMS" },
  { value: "25", type: "Record" },
  { value: "26", type: "URL Record" },
  { value: "28", type: "Group Listening" },
  { value: "29", type: "Public Hold" },
  { value: "30", type: "Private Hold" },
  { value: "32", type: "Hot Desking" },
  { value: "33", type: "ACD" },
  { value: "34", type: "Zero Touch" },
  { value: "35", type: "URL" },
  { value: "44", type: "Network Group" },
  { value: "47", type: "MultiCast Paging" },
  { value: "51", type: "Group Call Park" },
  { value: "52", type: "CallPark Retrieve" },
  { value: "56", type: "XML BLF" },
  { value: "57", type: "Silent Call" },
  { value: "58", type: "Smart BLF" },
  { value: "62", type: "Contact" },
];

const softKeyMenu = [
  { action: "NV", value: "0", type: "N/A" },
  { action: "A", value: "2", type: "Speed Dial" },
  { action: "A", value: "6", type: "Direct Pickup" },
  { action: "A", value: "7", type: "Group Pickup" },
  { action: "A", value: "9", type: "Intercom" },
  { action: "N", value: "11", type: "Prefix" },
  { action: "NV", value: "12", type: "Local Group" },
  { action: "RV", value: "13", type: "XML Group" },
  { action: "N", value: "14", type: "XML Browser" },
  { action: "NV", value: "15", type: "LDAP" },
  { action: "NV", value: "16", type: "Network Directories" },
  { action: "N", value: "18", type: "Forward" },
  { action: "NV", value: "21", type: "DND" },
  { action: "NV", value: "22", type: "Redial" },
  { action: "NV", value: "23", type: "Call Return" },
  { action: "NV", value: "24", type: "SMS" },
  { action: "NV", value: "36", type: "History" },
  { action: "DV", value: "37", type: "Directory" },
  { action: "NV", value: "38", type: "Menu" },
  { action: "NV", value: "39", type: "New SMS" },
  { action: "NV", value: "40", type: "Phone Status" },
  { action: "NV", value: "41", type: "Switch Account Up" },
  { action: "NV", value: "42", type: "Switch Account Down" },
  { action: "A", value: "43", type: "Local Phone Book" },
  { action: "NG", value: "44", type: "Network Group" },
  { action: "N", value: "45", type: "XML Phone Book" },
  { action: "NV", value: "46", type: "Network Call Log" },
  { action: "A", value: "52", type: "Call Park Retrieve" },
  { action: "NV", value: "54", type: "Next Linekey Page" },
  { action: "NV", value: "55", type: "Pre Linekey Page" },
];

const settingKeyMenu = [
  { action: "NV", value: "0", type: "N/A" },
  { action: "A", value: "2", type: "Speed Dial" },
  { action: "A", value: "6", type: "Direct Pickup" },
  { action: "A", value: "7", type: "Group Pickup" },
  { action: "A", value: "9", type: "Intercom" },
  { action: "N", value: "11", type: "Prefix" },
  { action: "NV", value: "12", type: "Local Group" },
  { action: "RV", value: "13", type: "XML Group" },
  { action: "N", value: "14", type: "XML Browser" },
  { action: "NV", value: "15", type: "LDAP" },
  { action: "NV", value: "16", type: "Network Directories" },
  { action: "N", value: "18", type: "Forward" },
  { action: "NV", value: "21", type: "DND" },
  { action: "NV", value: "22", type: "Redial" },
  { action: "NV", value: "23", type: "Call Return" },
  { action: "NV", value: "24", type: "SMS" },
  { action: "NV", value: "36", type: "History" },
  { action: "DV", value: "37", type: "Directory" },
  { action: "NV", value: "38", type: "Menu" },
  { action: "NV", value: "39", type: "New SMS" },
  { action: "NV", value: "40", type: "Phone Status" },
  { action: "NV", value: "41", type: "Switch Account Up" },
  { action: "NV", value: "42", type: "Switch Account Down" },
  { action: "A", value: "43", type: "Local Phone Book" },
  { action: "NG", value: "44", type: "Network Group" },
  { action: "N", value: "45", type: "XML Phone Book" },
  { action: "NV", value: "46", type: "Network Call Log" },
];

const networkGroupMenu = [
  { value: "50", type: "All Contacts" },
  { value: "51", type: "Group" },
  { value: "52", type: "Interoperability" },
  { value: "53", type: "Group Common" },
  { value: "54", type: "Enterprise Common" },
  { value: "55", type: "Personal" },
  { value: "56", type: "Custom Directories" },
];

const remotePhoneBookMenu = [
  { value: "60", type: "Remote Phonebook 1" },
  { value: "61", type: "Remote Phonebook 2" },
  { value: "62", type: "Remote Phonebook 3" },
  { value: "63", type: "Remote Phonebook 4" },
  { value: "64", type: "Remote Phonebook 5" },
];

const directoryMenu = [
  { value: "70", type: "Menu View" },
  { value: "72", type: "Local Contacts" },
  { value: "80", type: "LDAP Contacts" },
];

const accountOptions = [
  { value: "0", type: "Account 1" },
  { value: "1", type: "Account 2" },
  { value: "2", type: "Account 3" },
  { value: "3", type: "Account 4" },
  { value: "4", type: "Account 5" },
  { value: "5", type: "Account 6" },
  { value: "6", type: "Account 7" },
  { value: "7", type: "Account 8" },
  { value: "8", type: "Account 9" },
  { value: "9", type: "Account 10" },
  { value: "A", type: "Account 11" },
  { value: "B", type: "Account 12" },
  { value: "C", type: "Account 13" },
  { value: "D", type: "Account 14" },
  { value: "E", type: "Account 15" },
  { value: "F", type: "Account 16" },
];

const accountLineKeys = Array.from({ length: 16 }, (_, i) => i + 1);

const parseProvisioningString = (str) => {
  if (!str) return null;

  try {
    // Parse account section
    const accountMatches = str.match(/Account\(([^)]+)\)/g) || [];
    const account = accountMatches.map((acc) => ({
      accountNo: acc.match(/accountNo=([^,\s]+)/)?.[1] || "1",
      label: acc.match(/label=([^,\s)]+)/)?.[1] || "",
      extensionNo: acc.match(/extensionNo=([^,\s)]+)/)?.[1] || "NA",
    }));

    // Parse BLF section
    const blfMatches = str.match(/Blf\(([^)]+(?:\([^)]*\))?[^)]*)\)/g) || [];
    const blf = blfMatches.map((b) => ({
      key: b.match(/key=([^,\s]+)/)?.[1] || "",
      type: b.match(/type=([^,\s]+)/)?.[1] || "0",
      mode: b.match(/mode=([^,\s]+)/)?.[1] || "0",
      value: b.match(/value=([^,\s)]+)/)?.[1] || "",
      label: b.match(/label=([^,\s)]+)/)?.[1] || "NA",
      account: b.match(/account=([^,\s]+)/)?.[1] || "",
      extension: b.match(/extension=([^,\s)]+)/)?.[1] || "NA",
    }));

    // Parse SoftKey section
    const softKeyMatches = str.match(/SoftKey\(([^)]+)\)/g) || [];
    const softKey = softKeyMatches.map((sk, idx) => ({
      name: `SoftKey ${idx + 1}`,
      key: `${idx + 1}`,
      type: sk.match(/type=([^,\s]+)/)?.[1] || "0",
      label: sk.match(/label=([^,)]*)/)?.[1] || "",
      account: sk.match(/account=([^,\s]+)/)?.[1] || "",
      value: sk.match(/value=([^,)]*)/)?.[1] || "",
    }));

    // Parse SettingKey section
    const settingKeyMatches = str.match(/SettingKey\(([^)]+)\)/g) || [];
    const settingKeyLabels = [
      "Up",
      "Down",
      "Left",
      "Right",
      "Ok",
      "Cancel",
      "Mute",
      "CONF",
      "TRAN",
      "Hold",
    ];
    const settingKey = settingKeyMatches.map((sk, idx) => ({
      label: settingKeyLabels[idx] || `Setting ${idx + 1}`,
      key: `${idx + 1}`,
      type: sk.match(/type=([^,\s]+)/)?.[1] || "0",
      account: sk.match(/account=([^,\s]+)/)?.[1] || "",
      value: sk.match(/value=([^,)]*)/)?.[1] || "",
    }));

    // Parse SettingSingleKey section
    const settingSingleKeyMatches =
      str.match(/SettingSingleKey\(([^)]+)\)/g) || [];
    const settingSingleKeyLabels = [
      "Speaker",
      "Headset",
      "VM",
      "Volume Up",
      "Volume Down",
      "Redial",
    ];
    const settingSingleKey = settingSingleKeyMatches.map((ssk, idx) => ({
      label: settingSingleKeyLabels[idx] || `Setting ${idx + 1}`,
      key: `${idx + 1}`,
      active: ssk.match(/active=([^,\s)]+)/)?.[1] || "0",
    }));

    return {
      account: account.length > 0 ? account : null,
      blf: blf.length > 0 ? blf : null,
      programmableKey: {
        softKey: softKey.length > 0 ? softKey : null,
        settingKey: settingKey.length > 0 ? settingKey : null,
        settingSingleKey: settingSingleKey.length > 0 ? settingSingleKey : null,
      },
    };
  } catch (err) {
    console.error("Provisioning parse error:", err);
    return null;
  }
};

const FullConfigDialog = ({ open, onClose, onSubmit, rowData }) => {
  const [maxAccounts, setMaxAccounts] = useState(16);
  const [formData, setFormData] = useState(initialForm);
  const [extensionList, setExtensionList] = useState([]);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [loading, setLoading] = useState(false);
  const [ extension, setExtension] = useState("");
  
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  const keyMenu = Array.from({ length: 36 }, (_, i) => ({
    value: i + 1,
    label: `Key ${i + 1}`,
  }));

  useEffect(() => {
    if (open && rowData?.macAddress) {
      getExtensionList();
      fetchConfig(rowData.macAddress, rowData.productClass);
    }
    // if (rowData?.category === "IP2LP") {
    //   setMaxAccounts(2);
    // } else if (rowData?.category === "IP4LP") {
    //   setMaxAccounts(4);
    // } else if (rowData?.category === "IP6LP") {
    //   setMaxAccounts(6);
    // } else if (rowData?.category === "V.IP6LP") {
    //   setMaxAccounts(16);
    // } else {
    //   setMaxAccounts(16);
    // }
  }, [open, rowData]);

  // ---------------- Extension List ----------------
  const getExtensionList = async () => {
    try {
      const response = await application.post(
        "extensions/listAllExtnsionType",
        {
          requestExtensionType: ["phone", "agent", "softphone"],
        },
      );

      if (response?.data?.data) {
        setExtensionList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching extension list:", error);
      setExtensionList([]);
    }
  };

  // ---------------- Fetch Device Config ----------------
  const fetchConfig = async (mac, phone) => {
    setLoading(true);
    try {
      const response = await telemetry.post(
        `deviceManager/get/configuration/${mac}`,
      );

      const data = response.data.data?.scadaAsset?.[0];
      const parsed = parseProvisioningString(data?.deviceDetailsProvisioning);
      setExtension(data?.extensionNumber || "N/A");
      if (parsed) {
        setFormData({
          phoneSelect: phone,
          macAddress: mac,
          account: parsed.account || initialForm.account,
          blf: parsed.blf || initialForm.blf,
          programmableKey: {
            softKey:
              parsed.programmableKey?.softKey ||
              initialForm.programmableKey.softKey,
            settingKey:
              parsed.programmableKey?.settingKey ||
              initialForm.programmableKey.settingKey,
            settingSingleKey:
              parsed.programmableKey?.settingSingleKey ||
              initialForm.programmableKey.settingSingleKey,
          },
        });
      } else {
        resetFormData(mac, phone);
      }
    } catch (error) {
      console.error("Error loading config:", error);
      resetFormData(mac, phone);
    } finally {
      setLoading(false);
    }
  };

  // Reset form to initial state
  const resetFormData = (mac, phone) => {
    setFormData({
      ...JSON.parse(JSON.stringify(initialForm)),
      macAddress: mac,
      phoneSelect: phone,
    });
  };

  const menuProps = {
    PaperProps: { style: { maxHeight: 200 } },
  };

  // ---------------- Submit ----------------
  const handleSubmit = () => {
    // Validate form data
    if (!formData.macAddress) {
      setNotify({
        isOpen: true,
        message: "Error",
        type: "error",
        pagename: "Device Configuration",
        status: "MAC Address is missing. Please refresh and try again.",
      });
      return;
    }

    if (!formData.account || formData.account.length === 0) {
      setNotify({
        isOpen: true,
        message: "Error",
        type: "warning",
        pagename: "Device Configuration",
        status: "Account information is missing. Please load config first.",
      });
      return;
    }

    const finalPayload = {
      phoneSelect: formData.phoneSelect,
      macAddress: formData.macAddress,
      account: formData.account.map((acc) => ({
        accountNo: acc.accountNo || "",
        label: acc.label || "",
        extensionNo: acc.extensionNo || "NA",
      })),
      blf: formData.blf
        // .filter((b) => b.key && b.type && b.type !== "0") // Filter empty entries
        .map((b) => ({
          key: b.key,
          type: b.type,
          mode: b.mode || "0",
          value: b.value || "",
          label: b.label || "",
          account: b.account || "",
          extension: b.extension || "NA",
        })),
      programmableKey: {
        softKey: formData.programmableKey.softKey.map((sk) => ({
          key: sk.key,
          type: sk.type || "0",
          label: sk.label || "",
          account: sk.account || "",
          value: sk.value || "",
        })),
        settingKey: formData.programmableKey.settingKey.map((setk) => ({
          key: setk.key,
          type: setk.type || "0",
          account: setk.account || "",
          value: setk.value || "",
        })),
        settingSingleKey: formData.programmableKey.settingSingleKey.map(
          (ssk) => ({
            key: ssk.key,
            active: ssk.active || "0",
          }),
        ),
      },
    };

    onSubmit(finalPayload);
  };

  // ---------------- ACCOUNT HANDLERS ----------------
  const updateAccount = (i, field, value) => {
    const updated = [...formData.account];
    updated[i][field] = value;
    setFormData({ ...formData, account: updated });
  };

  const addAccount = () => {
    if (formData.account.length >= maxAccounts) {
      alert(`You can add a maximum of ${maxAccounts} accounts.`);
      return;
    }
    setFormData({
      ...formData,
      account: [
        ...formData.account,
        {
          accountNo: "",
          label: "",
          extensionNo: "NA",
          extensionName: "",
          rluCode: "",
        },
      ],
    });
  };

  const removeAccount = (i) => {
    const updated = [...formData.account];
    updated.splice(i, 1);
    setFormData({ ...formData, account: updated });
  };

  // ---------------- BLF HANDLERS ----------------
  const updateBLF = (i, field, value) => {
    const updated = [...formData.blf];
    updated[i][field] = value;
    setFormData({ ...formData, blf: updated });
  };

  const addBLF = () => {
    if (formData.blf.length >= 36) {
      alert("You can add a maximum of 36 Line Key entries.");
      return;
    }

    setFormData({
      ...formData,
      blf: [
        ...formData.blf,
        {
          key: "",
          type: "0",
          mode: "0",
          value: "",
          label: "",
          account: 0,
          extension: "NA",
          extensionName: "",
          rluCode: "",
        },
      ],
    });
  };

  const removeBLF = (i) => {
    const updated = [...formData.blf];
    updated.splice(i, 1);
    setFormData({ ...formData, blf: updated });
  };

  const updateSoftKey = (index, field, value) => {
    const updated = [...formData.programmableKey.softKey];
    updated[index][field] = value;

    setFormData({
      ...formData,
      programmableKey: {
        ...formData.programmableKey,
        softKey: updated,
      },
    });
  };

  const updateSettingKey = (index, field, value) => {
    const updated = [...formData.programmableKey.settingKey];
    updated[index][field] = value;

    setFormData({
      ...formData,
      programmableKey: {
        ...formData.programmableKey,
        settingKey: updated,
      },
    });
  };

  const updateSingleKey = (index, value) => {
    const updated = [...formData.programmableKey.settingSingleKey];
    updated[index].active = value ? "1" : "0";

    setFormData({
      ...formData,
      programmableKey: {
        ...formData.programmableKey,
        settingSingleKey: updated,
      },
    });
  };

  const getSoftKeyAction = (type) => {
    return softKeyMenu.find((x) => x.value === type)?.action;
  };

  const getSettingKeyAction = (type) => {
    return settingKeyMenu.find((x) => x.value === type)?.action;
  };

  const getAccountMenuByAction = (action) => {
    if (action === "RV") return remotePhoneBookMenu;
    if (action === "DV") return directoryMenu;
    if (action === "NG") return networkGroupMenu;
    return accountOptions;
  };

  const handleClose = () => {
    setFormData(JSON.parse(JSON.stringify(initialForm)));
    setNotify({
      isOpen: false,
      message: "",
      type: "",
      pagename: "",
      status: "",
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle
        sx={(theme) => ({
          ...CTLDialogContent(theme, { darkMode }),
          display: "flex",
          alignItems: "center",
          gap: 4,
        })}
      >
        {/* Title */}
        <Typography fontWeight={500}>Device Configuration</Typography>

        {/* MAC */}
        <Typography>
          <Typography component="span" fontWeight={500}>
            MAC-Address
          </Typography>
          {" - "}
          <Typography component="span" variant="subtitle1" color="text">
            {rowData?.macAddress || "N/A"}
          </Typography>
        </Typography>

        {/* IP */}
        <Typography>
          <Typography component="span" fontWeight={500}>
            IP-Address
          </Typography>
          {" - "}
          <Typography component="span" variant="subtitle1" color="text">
            {rowData?.ipAddress || "N/A"}
          </Typography>
        </Typography>

        <Typography>
          <Typography component="span" fontWeight={500}>
            Primary Extension
          </Typography>
          {" - "}
          <Typography component="span" variant="subtitle1" color="text">
            {extension || "N/A"}
          </Typography>
        </Typography>

        {/* Close */}
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", right: 12 }}
        >
          <CloseIcon color="error" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={(theme) => ({
          ...CTLDialogContent(theme, { darkMode }),
          maxHeight: "60vh",
          overflow: "auto",
        })}
      >
        {/* ---------------- ACCOUNTS ---------------- */}
        <Box
          sx={{
            mt: 2,
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            variant="h5"
            sx={{ flexGrow: 1, textAlign: "center" }}
            fontWeight={400}
          >
            Account
          </Typography>

          {/* <IconButton color="info" onClick={addAccount}>
            <AddCircleOutlineIcon />
          </IconButton> */}
        </Box>

        {formData.account.map((acc, i) => (
          <React.Fragment key={i}>
            <Box mt={1}>
              <Grid container spacing={2}>
                {/* Account No */}
                <Grid item xs={3.6}>
                  <FormControl fullWidth>
                    <InputLabel>Account No</InputLabel>
                    <Select
                      sx={{ minHeight: "45px" }}
                      MenuProps={menuProps}
                      value={acc.accountNo}
                      label="Account No"
                      onChange={(e) =>
                        updateAccount(i, "accountNo", e.target.value)
                      }
                    >
                      <MenuItem value={""}>Select Account</MenuItem>
                      {accountLineKeys.map((num, index) => (
                        <MenuItem key={index} value={num}>
                          Account {num}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Label */}
                <Grid item xs={3.6}>
                  <TextField
                    label="Label"
                    fullWidth
                    value={acc.label}
                    onChange={(e) => updateAccount(i, "label", e.target.value)}
                  />
                </Grid>

                {/* Extension Dropdown */}
                <Grid item xs={3.6}>
                  <FormControl fullWidth>
                    <InputLabel>Extension</InputLabel>
                    <Select
                      sx={{ minHeight: "45px" }}
                      value={acc.extensionNo}
                      label="Extension"
                      MenuProps={menuProps}
                      onChange={(e) => {
                        const ext = extensionList.find(
                          (x) => x.extensionNo == e.target.value,
                        );
                        updateAccount(i, "extensionNo", ext?.extensionNo);
                      }}
                    >
                      <MenuItem value={"NA"}>Select Extension</MenuItem>
                      {extensionList?.map((ext) => (
                        <MenuItem
                          key={ext?.extensionNo}
                          value={ext?.extensionNo}
                        >
                          {ext?.extensionNo} - {ext?.extensionName} -{" "}
                          {ext?.rluCode}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Delete */}
                <Grid item xs={1.2}>
                  <IconButton color="error" onClick={() => removeAccount(i)}>
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          </React.Fragment>
        ))}

        <MDButton
          color="info"
          variant="contained"
          size="small"
          sx={{
            mt: 1,
            px: 1.5,
            py: 0.5,
            fontSize: "0.75rem",
            textTransform: "none",
            borderRadius: "8px",
            minHeight: "28px",
          }}
          onClick={addAccount}
        >
          + Add
        </MDButton>

        {/* <Divider /> */}
        {/* ---------------- BLF ---------------- */}
        <Box
          sx={{
            mt: 2,
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h5"
            fontWeight={400}
            sx={{ flexGrow: 1, textAlign: "center" }}
          >
            Line Key
          </Typography>

          {/* <IconButton color="info" onClick={addBLF}>
            <AddCircleOutlineIcon />
          </IconButton> */}
        </Box>

        {formData.blf.map((b, i) => (
          <React.Fragment key={i}>
            <Box mt={1}>
              <Grid container spacing={2}>
                {/* Key */}
                <Grid item xs={1.8}>
                  <FormControl fullWidth>
                    <InputLabel>Key</InputLabel>
                    <Select
                      sx={{ minHeight: "45px" }}
                      value={b.key || ""}
                      label="Key"
                      MenuProps={menuProps}
                      onChange={(e) => {
                        updateBLF(i, "key", e.target.value);
                      }}
                    >
                      {keyMenu.map((item, index) => (
                        <MenuItem key={index} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Type */}
                <Grid item xs={1.8}>
                  <FormControl fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select
                      sx={{ minHeight: "45px" }}
                      value={b.type}
                      label="Type"
                      MenuProps={menuProps}
                      onChange={(e) => {
                        updateBLF(i, "type", e.target.value);
                      }}
                    >
                      {typeMenu.map((item, index) => (
                        <MenuItem key={index} value={item.value}>
                          {item.type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Value */}
                <Grid item xs={1.8}>
                  <TextField
                    label="Value"
                    fullWidth
                    value={b.value}
                    onChange={(e) => updateBLF(i, "value", e.target.value)}
                  />
                </Grid>

                {/* Label */}
                <Grid item xs={1.8}>
                  <TextField
                    label="Label"
                    fullWidth
                    value={b.label}
                    onChange={(e) => updateBLF(i, "label", e.target.value)}
                  />
                </Grid>

                {/* Account */}
                <Grid item xs={1.8}>
                  <FormControl fullWidth>
                    <InputLabel>Account</InputLabel>
                    <Select
                      sx={{ minHeight: "45px" }}
                      value={b.account}
                      label="Account"
                      MenuProps={menuProps}
                      onChange={(e) => updateBLF(i, "account", e.target.value)}
                    >
                      <MenuItem value={""}>Select Account</MenuItem>
                      {accountLineKeys.map((num, index) => (
                        <MenuItem key={index} value={num}>
                          Account {num}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Extension */}
                <Grid item xs={1.8}>
                  <FormControl fullWidth>
                    <InputLabel>Extension</InputLabel>
                    <Select
                      sx={{ minHeight: "45px" }}
                      value={b.extension}
                      label="Extension"
                      MenuProps={menuProps}
                      onChange={(e) => {
                        const ext = extensionList.find(
                          (x) => x?.extensionNo == e.target.value,
                        );
                        updateBLF(i, "extension", ext?.extensionNo);
                      }}
                    >
                      <MenuItem value={"NA"}>Select Extension</MenuItem>
                      {extensionList.map((ext) => (
                        <MenuItem
                          key={ext?.extensionNo}
                          value={ext?.extensionNo}
                        >
                          {ext?.extensionNo} - {ext?.extensionName} -{" "}
                          {ext?.rluCode}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Delete */}
                <Grid item xs={1}>
                  <IconButton color="error" onClick={() => removeBLF(i)}>
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          </React.Fragment>
        ))}

        <MDButton
          color="info"
          variant="contained"
          size="small"
          sx={{
            mt: 1,
            px: 1.5,
            py: 0.5,
            fontSize: "0.75rem",
            textTransform: "none",
            borderRadius: "8px",
            minHeight: "28px",
          }}
          onClick={addBLF}
        >
          + Add Line Key
        </MDButton>
        {/* <Divider /> */}
        {/* ---------------- PROGRAMMABLE KEYS ---------------- */}
        <Typography
          variant="h5"
          sx={{ mt: 4, mb: 2, textAlign: "center", fontWeight: "400" }}
        >
          Programmable Key
        </Typography>
        {/* Soft key */}
        {formData.programmableKey?.softKey.map((b, i) => {
          const action = getSoftKeyAction(b.type);

          const disableAccount = action === "N" || action === "NV";
          const disableValue =
            action === "NV" ||
            action === "RV" ||
            action === "DV" ||
            action === "NG";
          const accountMenu = getAccountMenuByAction(action);

          return (
            <Box key={i} mt={1}>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <MDTypography>{b.name}</MDTypography>
                </Grid>

                <Grid item xs={2.2}>
                  <FormControl fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select
                      sx={{ minHeight: "45px" }}
                      MenuProps={menuProps}
                      value={b.type}
                      label="Type"
                      onChange={(e) => {
                        updateSoftKey(i, "type", e.target.value);
                        updateSoftKey(i, "account", "");
                        updateSoftKey(i, "value", "");
                      }}
                    >
                      {softKeyMenu.map((t) => (
                        <MenuItem key={t.value} value={t.value}>
                          {t.type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={2.2}>
                  <TextField
                    label="Label"
                    fullWidth
                    value={b.label}
                    onChange={(e) => updateSoftKey(i, "label", e.target.value)}
                  />
                </Grid>

                <Grid item xs={2.2}>
                  <FormControl fullWidth>
                    <InputLabel disabled={disableAccount}>Account</InputLabel>
                    <Select
                      disabled={disableAccount}
                      sx={{ minHeight: "45px" }}
                      MenuProps={menuProps}
                      value={b.account}
                      label="Account"
                      onChange={(e) =>
                        updateSoftKey(i, "account", e.target.value)
                      }
                    >
                      <MenuItem value="">Select</MenuItem>
                      {accountMenu.map((num, index) => (
                        <MenuItem key={index} value={num.value}>
                          {num.type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={2.2}>
                  <TextField
                    disabled={disableValue}
                    label="Value"
                    fullWidth
                    value={b.value}
                    onChange={(e) => updateSoftKey(i, "value", e.target.value)}
                  />
                </Grid>
              </Grid>
            </Box>
          );
        })}

        <Divider />
        {/* Setting key */}
        {formData.programmableKey?.settingKey.map((b, i) => {
          const action = getSettingKeyAction(b.type);

          const disableAccount = action === "N" || action === "NV";
          const disableValue =
            action === "NV" ||
            action === "RV" ||
            action === "DV" ||
            action === "NG";
          const accountMenu = getAccountMenuByAction(action);

          return (
            <Box key={i} mt={1}>
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <MDTypography>{b.label}</MDTypography>
                </Grid>

                <Grid item xs={2.9}>
                  <FormControl fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select
                      sx={{ minHeight: "45px" }}
                      MenuProps={menuProps}
                      value={b.type}
                      label="Type"
                      onChange={(e) => {
                        updateSettingKey(i, "type", e.target.value);
                        updateSettingKey(i, "account", "");
                        updateSettingKey(i, "value", "");
                      }}
                    >
                      {settingKeyMenu.map((t) => (
                        <MenuItem key={t.value} value={t.value}>
                          {t.type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={2.9}>
                  <FormControl fullWidth>
                    <InputLabel disabled={disableAccount}>Account</InputLabel>
                    <Select
                      disabled={disableAccount}
                      sx={{ minHeight: "45px" }}
                      MenuProps={menuProps}
                      value={b.account}
                      label="Account"
                      onChange={(e) =>
                        updateSettingKey(i, "account", e.target.value)
                      }
                    >
                      <MenuItem value="">Select</MenuItem>
                      {accountMenu.map((num, index) => (
                        <MenuItem key={index} value={num.value}>
                          {num.type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={2.9}>
                  <TextField
                    disabled={disableValue}
                    label="Value"
                    fullWidth
                    value={b.value}
                    onChange={(e) =>
                      updateSettingKey(i, "value", e.target.value)
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          );
        })}

        <Divider />
        {/* Single Setting Key */}
        <Grid container spacing={2} direction="row" alignItems="center">
          {formData.programmableKey?.settingSingleKey.map((b, i) => (
            <React.Fragment key={i}>
              <Grid item xs={2}>
                <MDTypography>{b.label}</MDTypography>
              </Grid>

              <Grid item xs={1}>
                <Switch
                  checked={b.active === "1"}
                  onChange={(e) => updateSingleKey(i, e.target.checked)}
                />
              </Grid>

              <Grid item xs={1}>
                <MDTypography>
                  {b.active === "1" ? "Enabled" : "Disabled"}
                </MDTypography>
              </Grid>
              <Grid item xs={2}></Grid>
            </React.Fragment>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
        <MDButton
          variant="contained"
          color="secondary"
          onClick={handleClose}
          disabled={loading}
        >
          Cancel
        </MDButton>

        <MDButton
          variant="contained"
          color="success"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Processing..." : "Submit Configuration"}
        </MDButton>
      </DialogActions>

      <CTLNotification notify={notify} setNotify={setNotify} />
    </Dialog>
  );
};

export default FullConfigDialog;
